import React, { useState, useEffect } from 'react';
import Certificates from './Certificates';
import PaginationControls from './PaginationControls';
import { InfinitySpin } from 'react-loader-spinner';

// Helper to extract provider and year from description HTML
function extractMetadata(description) {
  let provider = '';
  let year = '';

  if (description) {
    // Extract provider
    const providerMatch = description.match(/<strong>Provider:<\/strong>\s*([^<]+)/i);
    if (providerMatch) {
      provider = providerMatch[1].trim();
    }

    // Extract completion date/year
    const dateMatch = description.match(/Completion Date:\s*([^<]+)/i);
    if (dateMatch) {
      const dateStr = dateMatch[1].trim();
      // Extract just the year
      const yearMatch = dateStr.match(/\d{4}/);
      if (yearMatch) {
        year = yearMatch[0];
      }
    }
  }

  return { provider, year };
}

function CertificateList({ certificates }) {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 8;
  const sortedCertificates = certificates.sort((a, b) => (a.id < b.id ? 1 : -1));
  const displayedCertificates = sortedCertificates.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  if (isLoading) {
    return (
      <div className="text-center mt-5">
        <InfinitySpin width="200" color="#0051AD" />
      </div>
    );
  }


  return (
    <section id="certificate" className="py-6 bg-bg-surface">
      <div className="relative z-10 max-w-5xl mx-auto px-6">
        <div className="title-box text-center section-header-reveal mb-6">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 tracking-tight text-text-primary">
            Certificates
          </h2>
          <div className="w-16 h-1 bg-primary mx-auto mb-6 rounded-full" />
          <p className="text-lg leading-relaxed max-w-2xl mx-auto text-reveal reveal-delay-1 text-text-secondary">
            Professional development credentials
          </p>
        </div>

        <div className="space-y-6">
          {displayedCertificates.map((certificate, index) => {
            const { provider, year } = extractMetadata(certificate.description);
            return (
              <div key={certificate.id} className={`card-reveal reveal-delay-${Math.min(index + 1, 8)}`}>
                <Certificates
                  title={certificate.title}
                  provider={provider}
                  year={year}
                  link={certificate.link}
                  certificateImageUrl={certificate.certificateImageUrl}
                />
              </div>
            );
          })}
        </div>

        {certificates.length > itemsPerPage && (
          <div className="mt-10">
            <PaginationControls
              pageCount={Math.ceil(certificates.length / itemsPerPage)}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </section>
  );
}

export default CertificateList;
